import { type Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import { type FeatureToggles } from '../feature-keys';

export const attributesMatchDefault = (
	node: PMNode,
	featureToggles: FeatureToggles,
	overrideDefaults: { [key: string]: unknown } = {},
): boolean => {
	if (!featureToggles.allowAttributesMatchDefault) {
		return true;
	}

	// @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
	const nodeTypeAttrs = node.type.attrs;
	if (
		!nodeTypeAttrs ||
		(Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0)
	) {
		return true;
	}

	const defaultAttrs: { [key: string]: unknown } = {};
	Object.keys(nodeTypeAttrs).forEach((key) => {
		defaultAttrs[key] = nodeTypeAttrs[key].default;
	});

	// The actual node defaults don't match the node defaults when interacting with a page
	// So we override for a correct comparison
	Object.keys(overrideDefaults).forEach((key) => {
		defaultAttrs[key] = overrideDefaults[key];
	});

	// Compare the node attributes to the default attributes
	for (const key in node.attrs) {
		if (node.attrs[key] !== defaultAttrs[key]) {
			return false;
		}
	}

	return true;
};
